module.exports = __webpack_public_path__ + "static/media/tasks-icon.fe2cd965.svg";